<template>
        <div v-if="areaPrice" :class="{ 'error-border-color': errorRow }" class="row nopads my-2 ">
            <div class="col-3 nopads pr-2">
                <select
                    id="area"
                    v-model="areaPrice.area.id"
                    class="form-select form-select-sm"
                    @change="updateEvent"
                >
                    <option
                        v-for="area in areas"
                        :key="area.id"
                        :value="area.id"
                    >
                        {{ area.name }}
                    </option>
                </select>
            </div>
            <div class="col-3 nopads pr-2">
                <select
                    id="area"
                    v-model="areaPrice.task_type.id"
                    class="form-select form-select-sm"
                    @change="updateEvent"
                >
                    <option
                        v-for="taskType in taskTypes"
                        :key="taskType.id"
                        :value="taskType.id"
                    >
                        {{ taskType.name }}
                    </option>
                </select>
            </div>
            <div class="col-3 nopads px-2">
                <div class="input-group input-group-sm">
                    <input
                        id="price"
                        v-model="priceValue"
                        type="number"
                        step="any"
                        class="form-control"
                        @blur="updateEvent"
                    />
                    <span class="input-group-text">{{ currency }}</span>
                </div>
            </div>
        </div>
</template>

<script>

export default {
    name: 'AreaPriceSelector',
    props: {
        index: {
            type: Number
        },
        errorRow: {
            type: Boolean,
            default: false
        },
        priceItem: {
            type: Object,
            default: null
        },
        areas: {
            type: Array,
            default() {
                return []
            }
        },
        taskTypes: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            areaPrice: null,
            priceValue: 0
        }
    },
    computed: {
        currency() {
            return import.meta.env.VITE_APP_CURRENCY || '€'
        }
    },
    mounted: function () {
        this.areaPrice = this.priceItem
        this.priceValue = this.areaPrice.price ? this.areaPrice.price / 100.0 : 0
    },

    methods: {
        updateEvent() {
            if (this.priceValue) {
                this.areaPrice.price = (this.priceValue * 100).toFixed(1)
            } else {
                this.areaPrice.price = null
            }
            this.$emit('priceUpdated', this.index, this.areaPrice)
            this.$emit('updateEvent')
        }
    }
}
</script>
